const buildQueryString = (params) => {
    const query = Object.entries(params)
        .filter(([_, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    return query.length ? `?${query}` : '';
};

const formatDateForFilename = () => {
    const now = new Date();

    const pad = (n) => n.toString().padStart(2, '0');

    const day = pad(now.getDate());
    const month = pad(now.getMonth() + 1);
    const year = now.getFullYear().toString().slice(-2); // ostatnie 2 cyfry
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());

    return `${day}${month}${year}_${hours}${minutes}`;
};

export default {
    buildQueryString,
    formatDateForFilename,
}